/* eslint-disable no-useless-constructor */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable no-mixed-spaces-and-tabs */
// eslint-disable-next-line no-unused-vars
import { SelfieSegmentation } from '@mediapipe/selfie_segmentation';
export default class ChromaKey
{
	capStream = null;
	paused = false;
	selfieSegmentation = null;
	backgroundImg = null;
	inputStream = null;
	bg = null;
	constructor()
	{
	}

	updateStream(stream)
	{
		this.capStream = null;
		this.canvasCtx = null;
		this.video = null;
		this.canvas = null;

		this.video = document.createElement('video');
		this.video.autoplay = true;
		this.video.srcObject = stream;

		this.canvas = document.createElement('canvas');
		this.canvasCtx = this.canvas.getContext('2d');

		this.video.addEventListener('play', () =>
		{
			this.width = this.canvas.width = this.video.videoWidth;
			this.height = this.canvas.height = this.video.videoHeight;
			this.timerCallback();
		}, false);

		this.capStream = this.canvas.captureStream();
	}

	updateBackground(bg)
	{
		this.backgroundImg = null;
		this.paused = true;
		this.bg = bg;
		this.backgroundImg = new Image();
		this.backgroundImg.src = `/images/banners/vc-banners/${this.bg}`;// +'.jpg';
		// this.backgroundImg.src = this.bg;// +'.jpg';

		// this.backgroundImg.src = 'https://pro.instavc.com/webapp/img/bookshelf.jpg'
		this.backgroundImg.onload = () =>
		{
			this.paused = false;
			this.timerCallback();
		};
	}

	async getImageFrame()
	{
		this.backgroundImg = new Image();

		if (this.bg.startsWith('https'))
		{
			this.backgroundImg.crossOrigin = 'anonymous';
			this.backgroundImg.alt = '';
			this.backgroundImg.src = this.bg;
		}
		else
		{
			this.backgroundImg.src = `/images/banners/vc-banners/${this.bg}`; // +'.jpg';
		}
		// this.backgroundImg.src = this.bg; //+'.jpg';

		// this.backgroundImg.src = 'https://pro.instavc.com/webapp/img/bookshelf.jpg'

		this.backgroundImg.onload = () =>
		{
			this.timerCallback();
		};
	}

	doLoad(stream, bg, blur)
	{
		this.bg = bg;
		this.video = document.createElement('video');
		this.video.autoplay = true;
		this.video.srcObject = stream;

		this.canvas = document.createElement('canvas');
		this.canvasCtx = this.canvas.getContext('2d');

		this.video.addEventListener('play', () =>
		{
			this.width = this.canvas.width = this.video.videoWidth;
			this.height = this.canvas.height = this.video.videoHeight;
			this.getImageFrame();
		}, false);

		this.capStream = this.canvas.captureStream();

		this.selfieSegmentation = new SelfieSegmentation({
			locateFile : (file) =>
			{

				return `https://cdn.jsdelivr.net/npm/@mediapipe/selfie_segmentation/${file}`;
			}
		});

		this.selfieSegmentation.setOptions({
			modelSelection         : 1, //  Use 0 to select the general model, and 1 to select the landscape model. Default to 0 if not specified.
			selfieMode             : false, //  自拍模式(即镜像)
			effect                 : 'mask',
			smoothSegmentationMask : true,
			enableFaceGeometry     : true,
			enableSmoothing        : true,
			minDetectionConfidence : 0.5,
			minTrackingConfidence  : 0.5
		});

		this.selfieSegmentation.onResults((results) =>
		{
			// this.canvasCtx.save();
			this.canvasCtx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			this.canvasCtx.imageSmoothingEnabled = false;
			this.canvasCtx.imageSmoothingQuality = 'medium';
			this.canvasCtx.drawImage(results.segmentationMask, 0, 0,
				this.canvas.width, this.canvas.height);

			// Only overwrite existing pixels.
			this.canvasCtx.globalCompositeOperation = 'source-in';
			// this.canvasCtx.globalAlpha = 0.5;
			this.canvasCtx.filter = 'none';
			this.canvasCtx.imageSmoothingEnabled = false;
			this.canvasCtx.imageSmoothingQuality = 'medium';
			this.canvasCtx.drawImage(results.image, 0, 0, this.canvas.width, this.canvas.height);

			// Only overwrite missing pixels.
			if ((blur === 'blur') || (blur === 'lightBlur'))
			{
				this.canvasCtx.globalCompositeOperation = 'destination-atop';
				this.canvasCtx.filter = blur === 'blur' ? 'blur(10px)' : 'blur(5px)';
				this.canvasCtx.drawImage(results.image, 0, 0, this.canvas.width, this.canvas.height);
				// this.canvasCtx.drawImage(this.backgroundImg, 0, 0, this.canvas.width, this.canvas.height);
			}
			else
			{
				this.canvasCtx.globalCompositeOperation = 'destination-atop';
				// this.canvasCtx.globalAlpha = 1.0;
				// this.canvasCtx.drawImage(results.image, 0, 0, this.canvas.width, this.canvas.height);
				this.canvasCtx.drawImage(this.backgroundImg, 0, 0, this.canvas.width, this.canvas.height);
			}

			// this.canvasCtx.restore();
		});

	}

	async timerCallback()
	{
		if (this.paused)
		{
			return;
		}
		if (this.video.paused || this.video.ended)
		{
			return;
		}
		// this.computeFrame();
		await this.sendFrame();
		setTimeout(() =>
		{
			this.timerCallback();
		}, 40);

	}

	async sendFrame()
	{
		await this.selfieSegmentation.send({ image: this.video });
	}

	close()
	{
		this.paused = true;
		this.bg = null;
		this.video = null;
		this.canvas = null;
		this.canvasCtx = null;
		this.capStream = null;
		this.selfieSegmentation = null;
	}
}